// src/services/utils/n8nResponse.js
export const extractHtmlFromN8n = (data) => {
  if (!data) return "";

  // n8n geralmente responde um array de items
  const arr = Array.isArray(data) ? data : [data];
  const first = arr[0] ?? {};

  // pode vir direto no item ou dentro de "json"
  const obj = first.json ? first.json : first;

  // priorizamos htmlFinal, depois html (e variações comuns)
  return (
    obj.htmlFinal ??
    obj.html ??
    obj.HTML ??
    obj.payloadHtml ??
    ""
  );
};
